import { useDictionaryStore } from 'bz-utilities/dictionary/dictionary-store';
import useComputed from 'bz-utilities/hooks/computed';

const useDictionarySentence = (sentence: string) => {
  const dictionary = useDictionaryStore();

  return useComputed(() => {
    return dictionary.format(sentence);
  }, [dictionary]);
};

export default useDictionarySentence;
